import { useState, useEffect } from "react";

export function useAddressFields({ jobID }) {
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [province, setProvince] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [jobsiteStreetName, setJobSiteStreetName] = useState("");
  const [projectname, setProjectName] = useState("");
  const [hasCondos, setHasCondos] = useState(null);
  const [housenumber, sethousenumber] = useState("");
  const [floorInfo, setFloorInfo] = useState("");
  const [longWalk, setLongWalk] = useState(null);
  const [standardDrill, setStandardDrill] = useState("");

  const [billingAddress, setBillingAddress] = useState("");
  const [billingCity, setBillingCity] = useState("");
  const [billingProvince, setBillingProvince] = useState("");
  const [billingPostalCode, setBillingPostalCode] = useState("");
  const [billingStreetName, setBillingStreetName] = useState("");
  const [isSameAsbillingAddress, setIsSameAsbillingAddress] = useState(false);

  // Reset condo fields whenever the job changes
  useEffect(() => {
    setHasCondos(null);
    sethousenumber("");
    setFloorInfo("");
    setLongWalk(null);
  }, [jobID]);

  return {
    address, setAddress,
    city, setCity,
    province, setProvince,
    postalCode, setPostalCode,
    jobsiteStreetName, setJobSiteStreetName,
    projectname, setProjectName,
    hasCondos, setHasCondos,
    housenumber, sethousenumber,
    floorInfo, setFloorInfo,
    longWalk, setLongWalk,
    standardDrill, setStandardDrill,
    billingAddress, setBillingAddress,
    billingCity, setBillingCity,
    billingProvince, setBillingProvince,
    billingPostalCode, setBillingPostalCode,
    billingStreetName, setBillingStreetName,
    isSameAsbillingAddress, setIsSameAsbillingAddress,
  };
}
